// src/views/Users/Customers/Customers.jsx
import { useState, useEffect, useRef } from "react";
import ActionsDataTable from "../../../shared/DataTable/ActionsDataTable";
import { globalConstants, invoiceConstants, modeConstants } from "../../../constants";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { activityActions, projectActions } from "../../../redux/actions";
import InvoiceModal from "../../../shared/Modals/InvoiceModal";
import InvoiceViewModal from "../../../shared/Modals/InvoiceViewModal";
import { SCREENS_IDS } from "../../../system";

export default function Invoices() {
  const initialGridState = {
    length: 10,
    pageNumber: 1,
    orderBy: "id desc",
    filterQuery: null,
    search: null,
    filterExpression: globalConstants.FILTER_EXPRESSION,
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [viewInvoice, setShowInvoice] = useState(false);
  const sortingInProgressRef = useRef(false);

  const [gridState, setGridState] = useState(initialGridState);
  const [defaultPage, setDefaultPage] = useState(initialGridState.pageNumber);
  const [rowData, setRowData] = useState({ items: [], total: 0 });
  const allData = useSelector((s) => s.activityReducer.invoices);

  // modal + row state (for Edit/View/Add Project)
  const [mode, setMode] = useState(modeConstants.ADD_MODE);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  // table columns

  const actions = 
    {
      name: "Actions",
      sortable: false,
      width: "170px",
      cell: (row) => (
        <div
          className="d-flex align-items-center gap-2"
          onClick={(e) => e.stopPropagation()}
        >
          {/* <button
            type="button"
            className="btn btn-sm btn-outline-primary"
            title="Edit"
            aria-label="Edit"
            onClick={() => {
              getRowData(row, modeConstants.UPDATE_MODE);
              setShowInvoiceModal(true);
            }}
          >
            <i className="bi bi-pencil" />
          </button> */}

          <button
            type="button"
            className="btn btn-sm btn-outline-success"
            title="View"
            aria-label="View"
            onClick={() => {
              getRowData(row);
            }}
          >
            <i className="bi bi-file-earmark-pdf" />
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    };

  const getRowData = (row) => {
    const payload = {
      activityId: 0 }
    dispatch(activityActions.generateInvoice(payload, row.id, setShowInvoice));
  };

  const toggleStatus = (id) => {
    dispatch(projectActions.deleteProjectById(id, 0));
  };

  const onSort = (sortedColumn, sortDirection) => {
    sortingInProgressRef.current = true;
    const columnDirection = sortDirection
      ? sortDirection.toUpperCase() // "ASC" | "DESC"
      : null;
    setDefaultPage(gridState.pageNumber);
    setGridState((prevState) => ({
      ...prevState,
      orderBy:
        columnDirection !== null ? `${sortedColumn} ${columnDirection}` : "",
    }));
  };

  const onChangePage = (pageNumber) => {
    if (!sortingInProgressRef.current) {
      setGridState((prevState) => ({
        ...prevState,
        pageNumber: pageNumber,
      }));
    }
  };

  const onChangeRowsPerPage = (newPerPage, pageNumber) => {
    setGridState((prevState) => ({
      ...prevState,
      length: newPerPage,
      pageNumber: pageNumber,
    }));
  };

  const getAll = () => {
    dispatch(activityActions.getAllInvoices(gridState));
  };
  useEffect(() => {
    if (allData !== null) {
      setRowData(allData);
    }
    // eslint-disable-next-line
  }, [allData]);

  useEffect(() => {
    getAll();
    sortingInProgressRef.current = false;
    // eslint-disable-next-line
  }, [gridState]);

  useEffect(() => {
    dispatch(activityActions.acceptedActivity())
  }, []);

  return (
    <>
      {/* Project modal (create/edit/view demo) */}
      <InvoiceModal
        show={showInvoiceModal}
        onHide={() => setShowInvoiceModal(false)}
        mode={mode}
        setShowInvoice={setShowInvoice}
      />
      <InvoiceViewModal
        show={viewInvoice}
        onHide={() => setShowInvoice(false)}
      />
      <ActionsDataTable
        actions={actions}
        data={rowData.items}
        pagination
        highlightOnHover
        striped
        responsive
        persistTableHead
        selectableRows
        selectableRowsHighlight
        selectableRowsVisibleOnly
        paginationServer
        onSort={onSort}
        gridState={gridState}
        paginationTotalRows={rowData.total}
        onChangeRowsPerPage={onChangeRowsPerPage}
        onChangePage={onChangePage}
        paginationDefaultPage={defaultPage}
        paginationResetDefaultPage
        setMode={setMode}
        setShowModal={setShowInvoiceModal}
        allowFilters={false}
        sortServer = {false}
        screenId={SCREENS_IDS.INVOICES}
      />
    </>
  );
}
